import { Component, Input, OnInit } from '@angular/core';
import { getServiceNotes } from '../itinerary/common/service-notes';

@Component({
  selector: 'app-escorted',
  templateUrl: './escorted.component.html',
  styleUrls: ['./escorted.component.scss']
})
export class EscortedComponent implements OnInit {
  @Input() public day: any;
  @Input() public days: any;
  @Input() public version: any;
  @Input() public noImageUrl: any;
  @Input() public defaultImage: any;
  @Input() public totalPax: number = 0;
  @Input() public replaceShowDescriptionButtonWithNotes: boolean = false;
  @Input() public serviceIcons: any;
  state: any = sessionStorage.getItem('state');

  public getServiceIconPath(name: string): string | undefined {
    return this.serviceIcons ? this.serviceIcons[name] : undefined;
  }

  public getFilteredNotes(notes: any): any[] {
    return getServiceNotes(notes, this.state);
  }

  constructor() { }

  ngOnInit(): void {
  }

}
